import React from 'react';
import { CommonModal, Input, LoadingButtonV4 } from '../Common';
import { Stack, Typography } from '@mui/material';

import "./Login.css";

const ForgotPasswordModal = ({
    forgotButtonModalOpen,
    setforgotButtonModalOpen,
    EmailForgotField,
    setEmailForgotField,
    handleKeyDown,
    error,
    forgotPassword,
    isLoading
}) => (
    <CommonModal
        open={forgotButtonModalOpen}
        close={() => setforgotButtonModalOpen(!forgotButtonModalOpen)}
        header="Forgot Your Password?"
    >
        <Stack
            alignContent="center"
            justifyContent="center"
            alignItems="center"
            gap="1.5rem"
            mb="1.5rem"
            p="5% 15%"
        >
            <Typography 
                sx={{  
                    textAlign: "center"
                }}
            >
                Enter your email address below and we will email you a link to reset your password.
            </Typography>
            <Input
                fullWidth
                variant='outlined'
                id="standard-basic"
                label="Email Address"
                value={EmailForgotField}
                onChange={e => setEmailForgotField(e.target.value)}
                onKeyDown={e => handleKeyDown(e)}
                error={error}
            />
            <LoadingButtonV4
                buttonText="RESET PASSWORD"
                loading={isLoading}
                onClick={forgotPassword}
            />
        </Stack>
    </CommonModal>
);

export default ForgotPasswordModal;